import { t } from 'i18next';
import React, { FC } from 'react';

import Detail from '../components/Detail';
import Progress from '../components/Progress';
import { EventResource } from '../models';

const ParticipantsCountDetail: FC<{ event: EventResource }> = ({ event }) => {
  const currentCount = event.attributes.participantsCount;
  const desiredCount = event.attributes.desiredCount;

  const text =
    desiredCount === 0 ? (
      currentCount.toString()
    ) : (
      <span>
        <Progress
          detail
          height="8px"
          max={desiredCount}
          maxWidth="10em"
          min={0}
          value={Math.min(currentCount, desiredCount)}
        />
        {` ${currentCount}/${desiredCount}`}
      </span>
    );

  return <Detail icon="users" text={text} title={t('details.participants')} />;
};

export default ParticipantsCountDetail;
